import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveSecondaryCriteriaTemplate,
} from "@planzone/view-models";
import { SecondaryCriteriaIcon } from "@common/secondaryCriteriaIcon";
import { Props } from "./types";
import { ValidationIcon } from "./validationIcon";
import { FolderIcon } from "@common/folderIcon";

function ColumnIcon({ criteriaKey, className }: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { template } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "timeRecord",
  );
  const iconMap = {
    resourceTask: (
      <SecondaryCriteriaIcon type="resource" className={className} />
    ),
    timeSpent: <SecondaryCriteriaIcon type="number" className={className} />,
    validation: <ValidationIcon className={className} />,
    project: <FolderIcon className={className} />,
    text: <SecondaryCriteriaIcon type="text" className={className} />,
    date: <SecondaryCriteriaIcon type="date" className={className} />,
    number: <SecondaryCriteriaIcon type="number" className={className} />,
    list: <SecondaryCriteriaIcon type="list" className={className} />,
    document: <SecondaryCriteriaIcon type="document" className={className} />,
    link: <SecondaryCriteriaIcon type="link" className={className} />,
    resource: <SecondaryCriteriaIcon type="resource" className={className} />,
  };
  const criteria = template.find(({ uuid }) => uuid === criteriaKey);

  return (
    iconMap[(criteria ? criteria.type : criteriaKey) as keyof typeof iconMap] ||
    iconMap.text
  );
}

export { ColumnIcon };
